var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 901,
    height: 415,
    viewBox: "0 0 901 415",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 284.424V415H1124V332.023L1070.74 315.421V209.256H1061.34V182.113H1055.76V163.646H1009.09V182.218H1003.82V209.597H995.57V337.453H970.428V175.373H911.037V118.596H878.386V106.529H858.16V89.2466H804.722V331.217H752.781V197.671H742.877V168.068H650.909V197.671H644.837V347.855H621.192V253.012H576.632V162.343H569.121V148.536H505.011V162.907H499.09V270.498H475.65V208.02H471.273V197.373H426.21V208.02H421.157V336.982H358.371V182.826L287.272 162.213V336.982H255.215V270.829H208.701V197.13H199.111V184.077H143.126V197.632H137.252V351.875H109.799V284.957H93.8553V154.289H84.8642V139.899H76.1129V127.933H56.8121V0H53.4554V127.933H32.5962V139.899H25.0437V154.289H16.7719V284.424H0Z",
    fill: "url(#paint0_linear_220_7)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_220_7",
    x1: 562,
    y1: 0,
    x2: 562,
    y2: 415,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.45
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#6900FF",
    stopOpacity: 0.28
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCity);
export default __webpack_public_path__ + "static/media/city.2a1d34ee42e7583b643a8548248ddc3f.svg";
export { ForwardRef as ReactComponent };